(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* AmiAera: bridge custom hamburger button to Dawn's <header-drawer> */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-amiaera-menu-toggle]');
    if (!trigger) return;
    var summary = document.querySelector('header-drawer details > summary');
    if (!summary) return;
    event.preventDefault();
    summary.click();
  });

  /* AmiAera: bridge custom search button to Dawn's <details-modal class="header__search"> */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-amiaera-search-toggle]');
    if (!trigger) return;
    var summary = document.querySelector('details-modal.header__search > details > summary');
    if (!summary) return;
    event.preventDefault();
    summary.click();
  });

  /* AmiAera: mirror drawer open state onto our hamburger button so the icon
     can flip between hamburger and close (matches Dawn's default behavior). */
  function amiAeraSyncDrawerState() {
    var details = document.querySelector('header-drawer details');
    if (!details) return;
    var isOpen = details.hasAttribute('open');
    document.querySelectorAll('[data-amiaera-menu-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    var details = document.querySelector('header-drawer details');
    if (!details) return;
    details.addEventListener('toggle', amiAeraSyncDrawerState);
    amiAeraSyncDrawerState();
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-ranking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var list = root.querySelector('[data-ranking-list]');
      if (!list) return;

      var dots = root.querySelectorAll('[data-ranking-dot]');
      var items = list.querySelectorAll('.top-ranking__item');
      if (items.length === 0) return;

      function goTo(index) {
        var target = items[index];
        if (!target) return;
        list.scrollTo({
          left: target.offsetLeft - list.offsetLeft,
          behavior: 'smooth',
        });
      }

      function updateActive() {
        if (dots.length === 0) return;
        var firstWidth = items[0].getBoundingClientRect().width || 1;
        var idx = Math.round(list.scrollLeft / firstWidth);
        if (idx < 0) idx = 0;
        if (idx > dots.length - 1) idx = dots.length - 1;
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
        }
      }

      for (var d = 0; d < dots.length; d++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            goTo(parseInt(dot.getAttribute('data-index'), 10) || 0);
          });
        })(dots[d]);
      }

      var raf = null;
      list.addEventListener(
        'scroll',
        function () {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(updateActive);
        },
        { passive: true }
      );

      updateActive();
    }

    document.querySelectorAll('.top-ranking').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();
})();
